// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .button-container {
        justify-content: center !important;
        display: flex;
        margin-bottom: 10px;
      }
    `, "",{"version":3,"sources":["webpack://./projects/ert/src/app/ert-kr998/ert-kr998.component.ts"],"names":[],"mappings":";MACM;QACE,kCAAkC;QAClC,aAAa;QACb,mBAAmB;MACrB","sourcesContent":["\n      .button-container {\n        justify-content: center !important;\n        display: flex;\n        margin-bottom: 10px;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
